import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

import { createRoot } from "react-dom/client";

import { store } from "./redux/store";
import { Provider } from "react-redux";

import LoadingIndicator from "./components/LoadingIndicator";

const NewsListing = lazy(() => import("./components/news/NewsListing"));
const NewsListingFilters = lazy(() => import("./components/news/NewsListingFilters"));
const EventsListing = lazy(() => import("./components/events/EventsListing"));
const EventsListingFilters = lazy(
  () => import("./components/events/EventsListingFilters")
);
const ChapterBlogsListingFilters = lazy(
  () => import("./components/chapterBlogsListing/ChapterBlogsListingFilters")
);
const ChapterBlogsListing = lazy(
  () => import("./components/chapterBlogsListing/ChapterBlogsListing")
);
const SpotlightsComponent = lazy(
  () => import("./components/SpotlightsComponent")
);
const CorporateEventsFilters = lazy(
  () => import("./components/corporateEvents/CorporateEventsFilters")
);
const CorporateEventsListing = lazy(
  () => import("./components/corporateEvents/CorporateEventsListing")
);
const ChapterEventsListing = lazy(
  () => import("./components/chapterEvents/ChapterEventsListing")
);
const ChapterEventsFilters = lazy(
  () => import("./components/chapterEvents/ChapterEventsFilters")
);
const ChaptersListingRedirect = lazy(
  () => import("./components/chapterEvents/ChaptersListingRedirect")
);
const NVKBSearchInput = lazy(
  () => import("./components/nvkbListing/NVKBSearchInput")
);
const NVKBListingFilters = lazy(
  () => import("./components/nvkbListing/NVKBListingFilters")
);
const NVKBListing = lazy(() => import("./components/nvkbListing/NVKBListing"));

const SiteSearchInput = lazy(
  () => import("./components/siteSearch/SiteSearchInput")
);

const SiteSearchListing = lazy(
  () => import("./components/siteSearch/SiteSearchListing")
);
const SiteSearchFilters = lazy(
  () => import("./components/siteSearch/SiteSearchFilters")
);

const ChapterEventsCalendarWidget = lazy(
  () => import("./components/chapterEventsCalendar/ChapterEventsCalendarWidget")
);

const FinLitListingFilters = lazy(
  () => import("./components/finLitListing/FinLitListingFilters")
);

const FinLitListing = lazy(
  () => import("./components/finLitListing/FinLitListing")
);

const SavingsBenefitsListingFilters = lazy(
  () => import("./components/savingsBenefits/SavingsBenefitsListingFilters")
);

const SavingsBenefitsListing = lazy(
  () => import("./components/savingsBenefits/SavingsBenefitsListing")
);

const DisciplineSummariesListingFilters = lazy(
  () => import("./components/disciplineSummaries/DisciplineSummariesListingFilters")
);

const DisciplineSummariesListing = lazy(
  () => import("./components/disciplineSummaries/DisciplineSummariesListing")
);

const OnlineCandidateDirectory = lazy(
  () => import("./components/onlineCandidateDirectory/OnlineCandidateDirectory")
);

const FormComponent = lazy(() => import("./formBuilder/formComponent"));

const MobileNavigation = lazy(
  () => import("./components/mobileNavigation/MobileNavigation")
);

const globalAny: any = global;
globalAny.React = React;
globalAny.ReactDOM = ReactDOM;
globalAny.createRoot = createRoot;

globalAny.NewsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <NewsListing {...props} />
    </Suspense>
  </Provider>
);
globalAny.NewsListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <NewsListingFilters {...props} />
    </Suspense>
  </Provider>
);

globalAny.EventsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <EventsListing {...props} />
    </Suspense>
  </Provider>
);
globalAny.EventsListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <EventsListingFilters {...props} />
    </Suspense>
  </Provider>
);
globalAny.SpotlightsComponent = (props: any) => (
  <Suspense fallback={<LoadingIndicator />}>
    <SpotlightsComponent {...props} />
  </Suspense>
);
globalAny.CorporateEventsFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <CorporateEventsFilters {...props} />
    </Suspense>
  </Provider>
);
globalAny.CorporateEventsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <CorporateEventsListing {...props} />
    </Suspense>
  </Provider>
);
globalAny.ChapterBlogsListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <ChapterBlogsListingFilters {...props} />
    </Suspense>
  </Provider>
);
globalAny.ChapterBlogsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <ChapterBlogsListing {...props} />
    </Suspense>
  </Provider>
);
globalAny.ChapterEventsFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <ChapterEventsFilters {...props} />
    </Suspense>
  </Provider>
);
globalAny.ChapterEventsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <ChapterEventsListing {...props} />
    </Suspense>
  </Provider>
);
globalAny.ChaptersListingRedirect = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <ChaptersListingRedirect {...props} />
    </Suspense>
  </Provider>
);
globalAny.NVKBListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <NVKBListingFilters {...props} />
    </Suspense>
  </Provider>
);
globalAny.NVKBListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <NVKBListing {...props} />
    </Suspense>
  </Provider>
);

globalAny.NVKBSearchInput = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <NVKBSearchInput {...props} />
    </Suspense>
  </Provider>
);

globalAny.SiteSearchInput = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <SiteSearchInput {...props} />
    </Suspense>
  </Provider>
);

globalAny.SiteSearchFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <SiteSearchFilters {...props} />
    </Suspense>
  </Provider>
);

globalAny.SiteSearchListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <SiteSearchListing {...props} />
    </Suspense>
  </Provider>
);

globalAny.ChapterEventsCalendarWidget = (props: any) => (
  <Suspense fallback={<LoadingIndicator />}>
    <ChapterEventsCalendarWidget {...props} />
  </Suspense>
);

globalAny.FinLitListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <FinLitListingFilters {...props} />
    </Suspense>
  </Provider>
);

globalAny.FinLitListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <FinLitListing {...props} />
    </Suspense>
  </Provider>
);

globalAny.SavingsBenefitsListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <SavingsBenefitsListingFilters {...props} />
    </Suspense>
  </Provider>
);

globalAny.SavingsBenefitsListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <SavingsBenefitsListing {...props} />
    </Suspense>
  </Provider>
);

globalAny.OnlineCandidateDirectory = (props: any) => (
  <Suspense fallback={<LoadingIndicator />}>
    <OnlineCandidateDirectory {...props} />
  </Suspense>
);

globalAny.FormComponent = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <FormComponent {...props} />
    </Suspense>
  </Provider>
);

globalAny.MobileNavigation = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <MobileNavigation {...props} />
    </Suspense>
  </Provider>
);

globalAny.DisciplineSummariesListingFilters = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <DisciplineSummariesListingFilters {...props} />
    </Suspense>
  </Provider>
);

globalAny.DisciplineSummariesListing = (props: any) => (
  <Provider store={store}>
    <Suspense fallback={<LoadingIndicator />}>
      <DisciplineSummariesListing {...props} />
    </Suspense>
  </Provider>
);

export default globalAny;
